module.exports = __webpack_public_path__ + "img/pwa-install.87f0629d.png";